/* Pinnacle Garage USA - personalised collection grid.
   - Learns from what this shopper looks at: product pages viewed (and how long), product cards clicked,
     add-to-cart, and searches. Stored only in this browser (localStorage "pgAff").
   - On collection pages: products made for the collection's make come first and cross-compatible products
     (made for another make but still fit, e.g. "Fits BMW" 5x120 wheels on the Honda page) simply go after
     everything else; universal wheels and parts stay mixed in. Inside each group the
     store order (best selling + conversion) is kept for new visitors, and blended with the shopper's
     interests the more they browse. Only the products already on the page are re-ordered -
     nothing is pulled in from other pages or other makes. */
(function () {
  var KEY = 'pgAff', MAXK = 60;
  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function bump(o, k, w) { if (!k) return; k = String(k).toUpperCase().trim(); if (!k) return; o[k] = (o[k] || 0) + w; }
  function trim(o) { var ks = Object.keys(o); if (ks.length <= MAXK) return; ks.sort(function (a, b) { return o[b] - o[a]; }).slice(MAXK).forEach(function (k) { delete o[k]; }); }
  var STOP = { THE: 1, AND: 1, FOR: 1, WITH: 1, STYLE: 1, FITS: 1, KIT: 1, '|': 1, W: 1, TO: 1 };
  function words(s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9 ]+/g, ' ').split(/\s+/).filter(function (w) { return w.length > 2 && !STOP[w] && !/^\d{4}$/.test(w); }); }

  function record(d, w) {
    if (!d) return;
    var a = load(); ['t', 'm', 's', 'v', 'b', 'w', 'p'].forEach(function (k) { a[k] = a[k] || {}; });
    // gentle decay so recent interest counts most
    ['t', 'm', 's', 'v', 'b', 'w', 'p'].forEach(function (k) { for (var x in a[k]) { a[k][x] *= 0.96; if (a[k][x] < 0.05) delete a[k][x]; } });
    bump(a.t, d.t, w); bump(a.v, d.v, w * 0.5); bump(a.s, d.s, w * 1.2);
    (d.m || []).forEach(function (m) { bump(a.m, m, w / Math.max(1, (d.m || []).length)); });
    (d.b || []).forEach(function (b) { bump(a.b, b, w); });
    words(d.n).slice(0, 8).forEach(function (x) { bump(a.w, x, w * 0.4); });
    if (d.id) bump(a.p, d.id, w);
    ['t', 'm', 's', 'v', 'b', 'w', 'p'].forEach(function (k) { trim(a[k]); });
    a.n = (a.n || 0) + 1; save(a);
  }
  function recordSearch(q) {
    var a = load(); a.w = a.w || {}; words(q).forEach(function (x) { bump(a.w, x, 1.5); }); trim(a.w); a.n = (a.n || 0) + 1; save(a);
  }

  /* ---------- signals ---------- */
  var pv = window.pgPV;
  if (pv) {
    record(pv, 2);
    var t0 = Date.now(), done = false;
    var stay = function () { if (done) return; if (Date.now() - t0 > 25000) { done = true; record(pv, 1.5); } };
    setTimeout(stay, 26000);
    document.addEventListener('submit', function (e) { var f = e.target; if (f && f.action && /\/cart\/add/.test(f.action)) record(pv, 4); }, true);
    document.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('[name="add"], .product-form__submit, [data-pg-buy]'); if (b) record(pv, 4); }, true);
  }
  try { var sq = new URLSearchParams(location.search).get('q'); if (sq && /\/search/.test(location.pathname)) recordSearch(sq); } catch (e) {}

  /* ---------- collection grid ---------- */
  var DATA = {};
  function ingest(root) {
    (root || document).querySelectorAll('script[data-pg-cdata]').forEach(function (s) {
      try { var j = JSON.parse(s.textContent); (j.p || []).forEach(function (p) { DATA[p.h] = p; }); DATA.__mk = j.mk; } catch (e) {}
    });
  }
  function handleOf(li) { var a = li.querySelector('a[href*="/products/"]'); if (!a) return null; var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : null; }

  function affinity(p, a) {
    if (!p) return 0; var s = 0, g = function (o, k) { return (o && k) ? (o[String(k).toUpperCase()] || 0) : 0; };
    s += g(a.t, p.t) * 1.0 + g(a.s, p.s) * 1.6 + g(a.v, p.v) * 0.3;
    var mm = 0; (p.m || []).forEach(function (m) { mm = Math.max(mm, g(a.m, m)); }); s += mm * 0.8;
    (p.b || []).forEach(function (b) { s += g(a.b, b) * 0.9; });
    var ww = 0; words(p.n).forEach(function (w) { ww += g(a.w, w); }); s += Math.min(ww, 6) * 0.7;
    s += g(a.p, p.id) * 0.6;
    return s;
  }

  var busy = false;
  function apply() {
    var ul = document.getElementById('product-grid'); if (!ul || busy) return; busy = true;
    try {
      ul.querySelectorAll('.pg-xdiv').forEach(function (d) { d.remove(); });
      var lis = [].slice.call(ul.children).filter(function (li) { return li.classList.contains('grid__item'); });
      if (lis.length < 2) return;
      var a = load(), n = a.n || 0, alpha = Math.min(0.6, n * 0.06);
      var rows = lis.map(function (li, i) { var p = DATA[handleOf(li)]; return { li: li, p: p, i: i, x: p && p.x ? 1 : 0, af: alpha ? affinity(p, a) : 0 }; });
      var max = 0; rows.forEach(function (r) { if (r.af > max) max = r.af; });
      rows.forEach(function (r) { var base = 1 - r.i / rows.length; r.sc = (1 - alpha) * base + (max ? alpha * (r.af / max) : 0); });
      rows.sort(function (q, r) { return (q.x - r.x) || (r.sc - q.sc) || (q.i - r.i); });
      var changed = rows.some(function (r, k) { return r.i !== k; });
      if (changed) rows.forEach(function (r) { ul.appendChild(r.li); });
      ul.setAttribute('data-pg-personal', alpha ? 'on' : 'default');
    } finally { [].slice.call(ul.children).forEach(function (li) { li.__pg = 1; }); busy = false; }
  }

  function sectionId() { var s = document.querySelector('script[data-pg-cdata]'); var sec = s && s.closest('.shopify-section'); return sec ? sec.id.replace(/^shopify-section-/, '') : null; }
  var lastUrl = location.href, sid = null;
  function refreshData() {
    if (!sid) return Promise.resolve();
    var u = location.pathname + location.search + (location.search ? '&' : '?') + 'section_id=' + encodeURIComponent(sid);
    return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (h) {
      var box = document.createElement('div'); box.innerHTML = h; ingest(box);
    }).catch(function () {});
  }

  function clicks(ul) {
    if (ul.__pgClk) return; ul.__pgClk = 1;
    ul.addEventListener('click', function (e) {
      var li = e.target.closest && e.target.closest('.grid__item'); if (!li) return;
      var p = DATA[handleOf(li)]; if (p) record(p, 1);
    }, true);
  }

  function init() {
    var ul = document.getElementById('product-grid'); if (!ul || !document.querySelector('script[data-pg-cdata]')) return;
    sid = sectionId(); ingest(); apply(); clicks(ul);
    var t = null;
    new MutationObserver(function () {
      if (busy) return;
      var g0 = document.getElementById('product-grid');
      if (!g0 || ![].slice.call(g0.children).some(function (li) { return !li.__pg; })) return;
      clearTimeout(t);
      t = setTimeout(function () {
        var g = document.getElementById('product-grid'); if (!g) return; clicks(g);
        var missing = [].slice.call(g.children).some(function (li) { var h = li.classList.contains('grid__item') && !li.classList.contains('pg-xdiv') && handleOf(li); return h && !DATA[h]; });
        if (missing || location.href !== lastUrl) { lastUrl = location.href; refreshData().then(apply); } else apply();
      }, 120);
    }).observe(document.getElementById('ProductGridContainer') || ul.parentNode, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();